import moment from 'moment';
import { useState } from 'react';
import Select, { components } from 'react-select';
import DateRangeComp from '../../../core/common/dateComponent/DateRangeComp';
import { LoadingComponent } from '../../../core/common/loadingComponent/LoadingComponent';
import NoRecordFound from '../../../core/common/noRecord/NoRecordFound';
import { useGetReportAllCompaniesQuery, useGetReportAllPDMsQuery, useGetReportPDMActSummaryQuery, useGetReportPerformanceMatrixViewQuery } from '../../../services/EndPointsApis';
const { Option } = components;
type Option = {
    value: string;
    label: string;
};

// Custom Option component to add checkboxes
const CheckboxOption = (props: any) => {
    return (
        <Option {...props} className='d-flex align-items-start gap-2'>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
            />{" "}
            <label>{props.label}</label>
        </Option>
    );
};
const PdmYoyReport = () => {
    const currentDate = moment().format('MM-DD-YYYY');

    const [filterByStartDate, setFilterByStartDate] = useState('01-01-1970');
    const [filterByEndDate, setFilterByEndDate] = useState(currentDate);
    const [localFilterByStartDate, setLocalFilterByStartDate] = useState('01-01-1970');
    const [localFilterByEndDate, setLocalFilterByEndDate] = useState(currentDate);
    const [filterByCompanyName, setFilterByCompanyName] = useState("");
    const [localFilterByCompanyName, setlocalFilterByCompanyName] = useState("");
    const [filterByPdmStatus, setFilterByPdmStatus] = useState("Active");
    const [localFilterByPdmStatus, setLocalFilterByPdmStatus] = useState("Active");
    const [filterByUserIds, setFilterByUserIds] = useState<string[]>([]);
    const [selectedUserIds, setSelectedUserIds] = useState<Option[]>([]);
    const [localFilterByUserIds, setLocalFilterByUserIds] = useState<string[]>([]);

    const { data: getReportAllCompanies, } = useGetReportAllCompaniesQuery('');
    const { data: getReportAllPDMs } = useGetReportAllPDMsQuery('');
    const { data: getReportPerformanceMatrixView, isLoading: performanceIsLoading, refetch: getReportPerformanceMatrixViewRefetch } = useGetReportPerformanceMatrixViewQuery({
        StartDate: filterByStartDate,
        EndDate: filterByEndDate,
        CompanyName: filterByCompanyName,
        PDMs: filterByUserIds.length > 0 ? filterByUserIds : null,
        PDMStatus: filterByPdmStatus,
    });

    const { data: getReportPDMActSummary, isLoading, refetch: getReportPDMActSummaryRefetch } = useGetReportPDMActSummaryQuery({
        StartDate: filterByStartDate,
        EndDate: filterByEndDate,
        CompanyName: filterByCompanyName,
        PDMs: filterByUserIds.length > 0 ? filterByUserIds : null,
        PDMStatus: filterByPdmStatus,
    });

    const handleDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        // setFilterByStartDate(startDateFormatted);
        // setFilterByEndDate(endDateFormatted);

        setLocalFilterByStartDate(startDateFormatted);
        setLocalFilterByEndDate(endDateFormatted);
    };
    const handleCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByStartDate('');
        setFilterByEndDate('');
        setLocalFilterByStartDate("");
        setLocalFilterByEndDate("");
    };

    const options = [
        { value: "Active", id: 1 },
        { value: "In Active", id: 2 },
    ];
    const handleFilterByCompanyName = (e: any) => {
        setlocalFilterByCompanyName(e.label);
    };

    const userIdsOptions: Option[] = getReportAllPDMs?.result?.map((pdmValues: any) => ({
        value: pdmValues.id,
        label: pdmValues.value,
    }));

    const handleUserIdsChange = (selected: Option[]) => {
        setSelectedUserIds(selected);
        setLocalFilterByUserIds(selected?.map((pdmValues) => pdmValues.value));
    };
    const handleFilterByPdmStatus = (e: any) => {
        setLocalFilterByPdmStatus(e.label);
    };
    const applyFilters = () => {
        setFilterByStartDate(localFilterByStartDate);
        setFilterByEndDate(localFilterByEndDate);
        setFilterByCompanyName(localFilterByCompanyName);
        setFilterByPdmStatus(localFilterByPdmStatus);
        setFilterByUserIds(localFilterByUserIds)

        getReportPDMActSummaryRefetch();
        getReportPerformanceMatrixViewRefetch();
        // getReportPerformanceTrigger({
        //     StartDate: localFilterByStartDate,
        //     EndDate: localFilterByEndDate,
        //     CompanyName: localFilterByCompanyName,
        //     PDMs: localFilterByUserIds.length > 0 ? localFilterByUserIds : null,
        //     PDMStatus: localFilterByPdmStatus,
        // });
        // getReportPDMActSummaryTrigger({
        //     StartDate: localFilterByStartDate,
        //     EndDate: localFilterByEndDate,
        //     CompanyName: localFilterByCompanyName,
        //     PDMs: localFilterByUserIds.length > 0 ? localFilterByUserIds : null,
        //     PDMStatus: localFilterByPdmStatus,
        // });

    };


    const resetFilters = () => {
        setFilterByStartDate('');
        setFilterByEndDate('');
        setFilterByCompanyName("");
        setlocalFilterByCompanyName('');
        setFilterByPdmStatus("");
        setLocalFilterByPdmStatus('');
        setLocalFilterByStartDate('');
        setLocalFilterByEndDate('');
        setLocalFilterByUserIds([])
        setFilterByUserIds([])
        setSelectedUserIds([])


    }
    const formatNumber = (value: any) =>
        value != null && !isNaN(value) ? Number(value).toFixed(2) : "";
    return (
        <div className="page-wrapper">
            <div className="content">
                <h4 className="page-title color-red mb-2">PDM YOY Report</h4>
                <div className="card">
                    <div className="card-body">
                        <div className="row align-items-end">
                            <div className="col-md-3 col-xl-2">
                                <div className='mt-2 w-100' >
                                    <label className='input-label fw-semibold'>Company</label>
                                    <Select
                                        className="select"
                                        options={getReportAllCompanies?.result?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                        value={localFilterByCompanyName && localFilterByCompanyName !== ''
                                            ? {
                                                value: localFilterByCompanyName,
                                                label: getReportAllCompanies?.result.find((option: any) => option.value === localFilterByCompanyName)?.value
                                            }
                                            : null
                                        }
                                        onChange={handleFilterByCompanyName}
                                        placeholder="Select an option"
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-xl-2">
                                <div className='mt-2 w-100' >
                                    <label className='input-label fw-semibold'>PDM</label>
                                    <Select
                                        isMulti
                                        options={userIdsOptions}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option: CheckboxOption }}
                                        onChange={(selected) => handleUserIdsChange(selected as Option[])} // Casting to Option[]
                                        value={selectedUserIds} // Directly use selectedDeptId as it is of type Option[]
                                        placeholder='Search...'
                                        className='filter-valueContainer'
                                    />
                                </div>
                            </div>
                            <div className="col-md-3 col-xl-2">
                                <div className='mt-2 w-100' >
                                    <label className='input-label fw-semibold'>PDM Status</label>
                                    <Select
                                        placeholder="Select an option"
                                        className="select"
                                        options={options?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id
                                        }))}
                                        value={
                                            localFilterByPdmStatus && localFilterByPdmStatus !== ''
                                                ? {
                                                    value: localFilterByPdmStatus,
                                                    label: options?.find((option: any) => option.value === localFilterByPdmStatus)?.value
                                                }
                                                : null
                                        }
                                        onChange={handleFilterByPdmStatus}
                                    />

                                </div>
                            </div>
                            <div className="col-md-3 col-xl-2">
                                <div className='mt-2 w-100' >
                                    <DateRangeComp
                                        label='PDM YOY Report'
                                        startDate={localFilterByStartDate || moment()}
                                        endDate={localFilterByEndDate || moment()}
                                        onApply={handleDateRangeChange} onCancel={handleCancelDateSelection}
                                        value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "MM-DD-YYYY"} 
                                        
                                        />
                                </div>
                            </div>
                            <div className="col-md-3 col-xl-2">
                                <div className='mt-2 w-100 d-flex gap-2' >
                                    <button className='btn btn-sm btn-primary'
                                        onClick={applyFilters}
                                    >Apply Filter</button>
                                    <button className='btn btn-sm btn-light' onClick={resetFilters}>Reset Filter</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className='card'>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4 className='text-center text-uppercase mb-3'>Performance</h4>
                                        <div className="table-responsive custom-table">
                                            <table className="table report-table datanew dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th rowSpan={2} className='sticky-column'>PDM</th>
                                                    </tr>
                                                    <tr>
                                                        <th></th>
                                                        <th className="text-end sticky-column">YTD</th>
                                                        <th className="text-end sticky-column">Last YTD</th>
                                                        <th className="text-end sticky-column">Trailing 12 Months</th>
                                                        <th className="text-end sticky-column">Lifetime</th>
                                                        <th className="text-end sticky-column">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!performanceIsLoading &&
                                                        <>
                                                            {getReportPerformanceMatrixView?.result?.length > 0 ? (
                                                                <>
                                                                    {getReportPerformanceMatrixView?.result?.map((data: any, index: any) => (
                                                                        <>
                                                                            {data?.pdmPerformanceMatrixViewExpandData?.map((pdmData: any, innerIndex: any) => (
                                                                                <tr key={`${index}-${innerIndex}`}>
                                                                                    {innerIndex === 0 && (
                                                                                        <td rowSpan={data.pdmPerformanceMatrixViewExpandData.length} className="sticky-column align-top text-wrap"
                                                                                            style={{ borderRight: '1px solid lightGray', width: '100px' }}>
                                                                                            {data?.pdm}
                                                                                        </td>
                                                                                    )}
                                                                                    <td>
                                                                                        <div style={{ width: 170 }} className='text-wrap'>{pdmData?.columnLabel}</div>
                                                                                    </td>
                                                                                    {/* <td className='text-end'
                                                                                        style={{
                                                                                            backgroundColor:
                                                                                                pdmData?.columnLabel === 'GB1 %' ?
                                                                                                    pdmData?.columnYtd < '51%' ? '#ff0303'
                                                                                                        : pdmData?.columnYtd >= 51 ? '#b5ba00'
                                                                                                            : pdmData?.columnYtd <= 65.99 ? '#008000' : 'transparent'  : 'transparent',
                                                                                            color: pdmData?.columnLabel === 'GB1 %'
                                                                                                ? pdmData?.columnYtd < 51
                                                                                                    ? 'white'
                                                                                                    : pdmData?.columnYtd >= 51 && pdmData?.columnYtd <= 65.99
                                                                                                        ? 'white'
                                                                                                        : 'white'
                                                                                                : '#6F6F6F',
                                                                                        }}>{pdmData?.columnYtd}</td> */}
                                                                                    {/* <td className='text-end'>{pdmData?.columnLastYtd}</td>
                                                                                    <td className='text-end'>{pdmData?.columnTrailing12Months}</td>
                                                                                    <td className='text-end'>{pdmData?.columnLifeTime}</td>
                                                                                    <td className='text-end'>{pdmData?.columnTotal}</td> */}
                                                                                    {['columnYtd', 'columnLastYtd', 'columnTrailing12Months', 'columnLifeTime', 'columnTotal'].map((column) => (
                                                                                        <td
                                                                                            key={column}
                                                                                            className="text-end"
                                                                                            style={{
                                                                                                backgroundColor:
                                                                                                    pdmData?.columnLabel === 'GB1 %' || pdmData?.columnLabel === 'GB2 %' ||
                                                                                                        pdmData?.columnLabel === 'GB3+ %' || pdmData?.columnLabel === 'GB Closing %' ||
                                                                                                        pdmData?.columnLabel === 'Closing %'
                                                                                                        ? pdmData[column] < '51%'
                                                                                                            ? '#ff0303'
                                                                                                            : pdmData[column] >= '51%' && pdmData[column] <= '65.99%'
                                                                                                                ? '#b5ba00'
                                                                                                                : '#008000'
                                                                                                        : 'transparent',
                                                                                                color: pdmData?.columnLabel === 'GB1 %' || pdmData?.columnLabel === 'GB2 %' ||
                                                                                                    pdmData?.columnLabel === 'GB3+ %' || pdmData?.columnLabel === 'GB Closing %' ||
                                                                                                    pdmData?.columnLabel === 'Closing %'
                                                                                                    ? pdmData[column] < '51%'
                                                                                                        ? 'white'
                                                                                                        : pdmData[column] >= '51%' && pdmData[column] <= '65.99%'
                                                                                                            ? 'white'
                                                                                                            : 'white'
                                                                                                    : '#6F6F6F',
                                                                                            }}
                                                                                        >
                                                                                            {pdmData[column]}
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </>
                                                                    ))}
                                                                </>
                                                            ) :
                                                                (
                                                                    <tr>
                                                                        <td colSpan={15}>
                                                                            <NoRecordFound />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </>
                                                    }
                                                    {performanceIsLoading && (
                                                        <tr>
                                                            <td colSpan={15} className="text-center">
                                                                <LoadingComponent />
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <h4 className='text-center text-uppercase mb-3'>Activity</h4>
                                        <div className="table-responsive custom-table">
                                            <table className="table report-table datanew dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th rowSpan={2} className='sticky-column'>PDM</th>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-end"></th>
                                                        <th className="text-end">YTD</th>
                                                        <th className="text-end">Last YTD</th>
                                                        <th className="text-end">Trailing 12 Months</th>
                                                        <th className="text-end">Lifetime</th>
                                                        <th className="text-end">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!isLoading &&
                                                        <>
                                                            {getReportPDMActSummary?.result?.length > 0 ? (
                                                                <>
                                                                    {getReportPDMActSummary?.result?.map((data: any, index: any) => (
                                                                        <>
                                                                            {data?.pdmActSummaryData?.map((pdmData: any, innerIndex: any) => (
                                                                                <tr key={`${index}-${innerIndex}`}>
                                                                                    {innerIndex === 0 && (
                                                                                        <td rowSpan={data.pdmActSummaryData.length} className="sticky-column align-top text-wrap"
                                                                                            style={{ borderRight: '1px solid lightGray', width: '100px' }}>
                                                                                            {data?.pdm}
                                                                                        </td>
                                                                                    )}
                                                                                    <td>{pdmData?.columnLabel}</td>
                                                                                    {/* <td className='text-end'>{pdmData?.columnYtd}</td>
                                                                                    <td className='text-end'>{pdmData?.columnLastYtd}</td>
                                                                                    <td className='text-end'>{pdmData?.columnTrailing12Months}</td>
                                                                                    <td className='text-end'>{pdmData?.columnLifeTime}</td>
                                                                                    <td className='text-end'>{pdmData?.columnTotal}</td> */}
                                                                                    {['columnYtd', 'columnLastYtd', 'columnTrailing12Months', 'columnLifeTime', 'columnTotal'].map((column) => (
                                                                                        <td
                                                                                            key={column}
                                                                                            className="text-end"
                                                                                            style={{
                                                                                                backgroundColor:
                                                                                                    pdmData?.columnLabel === 'At BAT %'
                                                                                                        ? pdmData[column] < '51%'
                                                                                                            ? '#ff0303'
                                                                                                            : pdmData[column] >= '51%' && pdmData[column] <= '65.99%'
                                                                                                                ? '#b5ba00'
                                                                                                                : '#008000'
                                                                                                        : 'transparent',
                                                                                                color: pdmData?.columnLabel === 'At BAT %'
                                                                                                    ? pdmData[column] < '51%'
                                                                                                        ? 'white'
                                                                                                        : pdmData[column] >= '51%' && pdmData[column] <= '65.99%'
                                                                                                            ? 'white'
                                                                                                            : 'white'
                                                                                                    : '#6F6F6F',
                                                                                            }}
                                                                                        >
                                                                                            {pdmData[column]}
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </>
                                                                    ))}
                                                                </>
                                                            ) :
                                                                (
                                                                    <tr>
                                                                        <td colSpan={15}>
                                                                            <NoRecordFound />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </>
                                                    }
                                                    {isLoading && (
                                                        <tr>
                                                            <td colSpan={15} className="text-center">
                                                                <LoadingComponent />
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PdmYoyReport